import API from './API';
import { POST } from '../utils/Executer';

const SEARCH_ENDPOINT = '/v1/search';

class SearchServiceAPI {
  async search({ query, filters, limit = 100, page, groupBy } = {}) {
    return await API.client.execute(POST, SEARCH_ENDPOINT, {
      query,
      filters,
      limit,
      page,
      groupBy,
    });
  }
}

export default new SearchServiceAPI();
